import { JsonRpcProvider, JsonRpcSigner } from 'ethers';

import { ChainInfo } from '../ChainInfo';
import { ConnectSuccessData, GetWalletAPI } from '../WalletAPI';

export function telegramMiniAppAPI({
  addressGetter,
}: {
  addressGetter: () => string | undefined;
}): GetWalletAPI {
  return ({ type }) => {
    const address = addressGetter() ?? '';
    let currentChainInfo: ChainInfo;

    return {
      type,
      getSigner: (): Promise<JsonRpcSigner | undefined> =>
        new Promise((resolve, reject) => {
          const provider = new JsonRpcProvider(currentChainInfo?.rpc);
          const signer = new JsonRpcSigner(provider, address);

          resolve(signer);
        }),
      connect: ({ chainInfo }): Promise<ConnectSuccessData> => {
        const chainId = parseInt(chainInfo.chainId, 10);
        currentChainInfo = chainInfo;

        if (address === undefined || !chainId) {
          throw new Error(
            'Wallet address or chainId is undefined. Try to reload the page',
          );
        }

        return Promise.resolve({
          address,
          chainId,
        });
      },
    };
  };
}
